import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.label`
  ${({ theme }) => css`
    height: 43px;
    min-width: 292px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      border: 1px solid ${theme?.colour?.primary ?? '#1DBD6B'};
    }

    color: ${theme?.colour?.secondary};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-decoration-line: underline;
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template: template })
